import { createSlice } from '@reduxjs/toolkit';
import {
  getNotificationCounterThunk,
  getNotificationsListThunk,
} from './NotificationThunk';
import { Notification } from './NotificationType';

export const notificationSlice = createSlice({
  name: 'notifications',
  initialState: {
    counter: 0,
    list: {
      items: [] as Notification[],
      loading: true,
      pagination: {},
    },
  },
  reducers: {
    resetNotificationCounter: state => ({
      ...state,
      counter: 0,
    }),
    resetNotificationList: state => ({
      ...state,
      list: {
        ...state.list,
        items: [],
        loading: true,
        pagination: {},
      },
    }),
  },
  extraReducers: builder => {
    builder.addCase(getNotificationsListThunk.pending, (state, action) => ({
      ...state,
      list: {
        ...state.list,
        loading: true,
      },
    }));
    builder.addCase(getNotificationsListThunk.fulfilled, (state, action) => {
      const { data, pagination: _pagination } = action.payload;
      const newData = Array.isArray(data) ? data : [];
      const pagination = {
        currentPage: _pagination.current_page,
        lastPage: _pagination.last_page,
        total: _pagination.total,
      };
      state.list = {
        ...state.list,
        pagination,
        loading: false,
        // it's 1 and not 0 because our backend start pages from 1 and not 0
        // thus, the first page is the page 1
        items: pagination.currentPage === 1
        ? [...newData]
        : [...state.list.items, ...newData],
      };
    });

    builder.addCase(getNotificationsListThunk.rejected, (state, action) => ({
      ...state,
      list: {
        ...state.list,
        loading: false,
      },
    }));
    // Notification counter thunk
    builder.addCase(getNotificationCounterThunk.fulfilled, (state, action) => {
      const { data } = action.payload;
      state.counter = data.counter;
    });
  },
});

export const { resetNotificationCounter, resetNotificationList } =
  notificationSlice.actions;
export const getNotificationsCounter = (state: any) =>
  state.notifications.counter;
export const getNotificationsList = (state: any) => state.notifications.list;

export default notificationSlice.reducer;
